export const pipelineData = [
  {
    previousNodes: [],
    currentNode: { nodeId: 'dndnode_11750309810001', nodeName: 'ReadCSV' },
    formData: {
      formField: {
        alias: 'support_tickets',
        dataTypeRead: 'refernce',
        delimiter: ',',
        format: 'csv',
        path: 's3://dep-qa/inputs/support_tickets_updated.csv',
        sample_view: true,
        pathTypeFile: 'filepath',
      },
      headerName: [
        { header: 'ticket_id', checked: 'true' },
        { header: 'customer_id', checked: 'true' },
        { header: 'issue', checked: 'true' },
        { header: 'timestamp', checked: 'true' },
        { header: 'status', checked: 'true' },
      ],
    },
    step_no: 1,
    x_level: 1,
  },
  {
    previousNodes: [],
    currentNode: { nodeId: 'dndnode_11750309810002', nodeName: 'ReadCSVAws' },
    formData: {
      formField: {
        alias: 'customer_1',
        connection_type: 'default',
        dataTypeRead: 'refernce',
        delimiter: ',',
        format: 'read_csv_aws',
        path: 's3://dep-qa/inputs/Customer_1.csv',
        sample_view: true,
        pathTypeFile: 'filepath',
      },
      headerName: [
        { header: 'customer_id', checked: 'true' },
        { header: 'name', checked: 'true' },
        { header: 'country', checked: 'true' },
        { header: 'phone', checked: 'true' },
        { header: 'email', checked: 'true' },
      ],
    },
    step_no: 2,
    x_level: 1,
  },
  {
    previousNodes: [
      { nodeId: 'dndnode_11750309810001', nodeName: 'ReadCSV' },
      { nodeId: 'dndnode_11750309810002', nodeName: 'ReadCSVAws' },
    ],
    currentNode: { nodeId: 'dndnode_11750309810003', nodeName: 'Join' },
    formData: {
      formField: {
        alias: 'join_data',
        join_conditions: 'support_tickets.customer_id=customer_1.customer_id',
        select_cols:
          'support_tickets.ticket_id,support_tickets.issue,support_tickets.timestamp,support_tickets.status,customer_1.customer_id,customer_1.name,customer_1.country,customer_1.phone,customer_1.email',
        tables: {
          table1: 'support_tickets',
          table2: 'customer_1',
        },
        joins: {
          join1: 'inner',
        },
      },
      count: {
        count_1: 1,
        count_2: 1,
      },
      onRow: [
        {
          row: 'row1',
          count: 'count_1',
          table1: 'support_tickets.customer_id',
          table2: 'customer_1.customer_id',
        },
      ],
      headerName: [
        { header: 'support_tickets.ticket_id', checked: 'true' },
        { header: 'support_tickets.customer_id', checked: 'false' },
        { header: 'support_tickets.issue', checked: 'true' },
        { header: 'support_tickets.timestamp', checked: 'true' },
        { header: 'support_tickets.status', checked: 'true' },
        { header: 'customer_1.customer_id', checked: 'true' },
        { header: 'customer_1.name', checked: 'true' },
        { header: 'customer_1.country', checked: 'true' },
        { header: 'customer_1.phone', checked: 'true' },
        { header: 'customer_1.email', checked: 'true' },
      ],
    },
    step_no: 3,
    x_level: 2,
  },
  {
    previousNodes: [{ nodeId: 'dndnode_11750309810003', nodeName: 'Join' }],
    currentNode: {
      nodeId: 'dndnode_11750309810004',
      nodeName: 'Filter',
    },
    formData: {
      formField: {
        alias: 'filter_data',
        df: 'join_data',
        statement:
          'SELECT ticket_id ,issue ,timestamp ,status ,customer_id ,name ,country ,phone ,email FROM join_data  WHERE (country = India) ',
      },
      sorting: [
        {
          oper: '=',
          clause: 'AND',
          filter: `'India'`,
          header: 'country',
          condition: 'Condition_Group_1',
        },
      ],
      attributes: ['Condition_Group_1'],
      addClause: [
        {
          count: '1',
          clause: 'AND',
          condition: 'Condition_Group_1',
        },
      ],
      headerName: [
        { header: 'ticket_id', checked: 'true' },
        { header: 'issue', checked: 'true' },
        { header: 'timestamp', checked: 'true' },
        { header: 'status', checked: 'true' },
        { header: 'customer_id', checked: 'true' },
        { header: 'name', checked: 'true' },
        { header: 'country', checked: 'true' },
        { header: 'phone', checked: 'true' },
        { header: 'email', checked: 'true' },
      ],
    },
    step_no: 4,
    x_level: 3,
  },
  {
    previousNodes: [{ nodeId: 'dndnode_11750309810004', nodeName: 'Filter' }],
    currentNode: { nodeId: 'dndnode_11750309810005', nodeName: 'WriteCsvAWS' },
    formData: {
      toggleType: 'S3',
      formField: {
        df: 'filter_data',
        alias: 'Customer_360',
        format: 'csv',
        connection_type: 'default',
        path: 'dep-qa/Internal/POC/Copilot Json Test/Output/Customer_360',
        mode: 'overwrite',
      },
    },
    step_no: 5,
    x_level: 4,
  },
];
